import React, { useState, useEffect } from "react"
import styled from "styled-components"
import {
  Button,
  Dialog,
  Grid,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  TextareaAutosize,
  IconButton,
  TextField,
  FormHelperText,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Radio,
} from "@material-ui/core"
import AttachFileIcon from "@material-ui/icons/AttachFile"
import DeleteIcon from "@material-ui/icons/Delete"

const buttonStyles = {
  minWidth: "80px",
  height: "40px",
  fontSize: "13px",
  fontWeight: "700",

  '@media(max-width:425px)': {
    padding: "5px",
    '& .MuiSvgIcon-root': {
      fontSize: "15px",
    },
    '& .MuiButton-label': {
      fontSize: "10px",
    }
  }
}

const ActionComments = (props) => {

  const {
    open = false,
    status = "",
    handleCommentsClose = () => {},
    setCommentsOpen = () => {},
    getCommentsReason = "",
    submitButtonLabel = "",
    onSubmit = () => "",
    placeholder = "Type here"
  } = props

  const [getOpen, setGetOpen] = useState(false)
  const [commentsReason, setCommentsReason] = useState("")
  const [required, setRequired] = useState(false);
  const [requiredError, setRequiredError] = useState(false);

  useEffect(() => {
    if (open) {
      if (status === 'New' && submitButtonLabel === 'Move to Resolved') {
        setRequired(true)
      } else {
        setRequired(false)
      }
    }
  }, [open])

  useEffect(() => {
    setCommentsReason(getCommentsReason)
    setGetOpen(open)
  }, [open])

  const handleClose = () => {
    handleCommentsClose(false)
    setCommentsOpen(false)
  }
  const handleChange = (event) => {
    setCommentsReason(event.target.value)
  }

  return (
    <Dialog
      open={getOpen}
      onClose={handleClose}
      aria-labelledby="draggable-dialog-title"
      style={{ width: "410px", marginLeft: "auto", marginRight: "auto" }}
    >
      <Divider orientation="horizontal" flexItem />
      <Grid
        container
        direction="row"
        style={{ padding: "20px 15px 10px 15px" }}
      >
        <Grid item container xs={12}
          style={{
            marginBottom: '10px'
          }}
        >
          <Typography
            variant="h5"
            style={{
              marginBottom: "14px",
              marginLeft: "4px",
              fontWeight: "600",
            }}

          >
            Comments
            {required && (<>
              <span style={{ color: "red" }}>
                {"*"}
              </span>
            </>)}
          </Typography>

          <TextField
            type="text"
            variant="outlined"
            name="TaxFailureReason"
            placeholder={required ? placeholder : placeholder + ' (Optional)'}
            multiline
            rows={6}
            value={commentsReason}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 255) {
                setCommentsReason(value);
              }
              if (value.length > 0 && requiredError) {
                setRequiredError(false)
              }
            }}
            helperText={
              requiredError ? 'This field is required' :
                (commentsReason.length < 255)
                  ? `${commentsReason.length}/255`
                  : `Maximum 255 character only`
            }
            error={requiredError ? requiredError : commentsReason.length >= 255}
            required={required}
            style={{
              width: "350px",
              height: "150px",
              fontFamily: `unset`,
              backgroundcolor: "#edf3f3",
              borderRadius: "10px",
            }}
          />
        </Grid>
        <div
          style={{
            padding: 5,
          }}
        >
          <Button
            variant="outlined"
            color="default"
            style={{
              ...buttonStyles,
              borderColor: "var(--primaryColor)",
              color: "var(--primaryColor)"
            }}
            onClick={handleClose}
          >
            Cancel
          </Button>
        </div>
        <div
          style={{
            padding: 5,
          }}
        >
          <Button
            variant="contained"
            color="default"
            style={{
              ...buttonStyles,
              backgroundColor: "var(--primaryColor)",
              color: "white"
            }}
            onClick={() => {
              if (required) {
                if (commentsReason.length > 0) {
                  onSubmit(commentsReason, handleClose)
                }
                setRequiredError(commentsReason.length === 0)
              } else {
                onSubmit(commentsReason, handleClose)
              }
            }}
          >
            {submitButtonLabel}
          </Button>
        </div>
      </Grid>
    </Dialog>
  )
}

export { ActionComments }
export default ActionComments

